module.exports = __webpack_public_path__ + "static/img/H6BAN2.cca35961.jpg";